import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';
import Helmet from 'react-helmet';

interface Props {
  description?: string;
  lang?: string;
  meta?: any;
  keywords?: any;
  title: string;
  image?: string;
}
const CDN_BASE_URL = 'https://cdn.banksalad.com';

const Head: React.FC<Props> = ({
  description = '뱅크샐러드 공식 블로그 입니다.',
  lang = 'ko',
  meta = [],
  keywords = [],
  title,
  image = 'https://cdn.banksalad.com/app/meta/introduce-a/og_blog.png',
}) => {
  const { site } = useStaticQuery(
    graphql`
      query {
        site {
          siteMetadata {
            title
            description
            author
          }
        }
      }
    `
  );

  return (
    <Helmet
      htmlAttributes={{
        lang,
      }}
      title={title}
      meta={[
        {
          name: 'description',
          content: description,
        },
        {
          property: 'og:title',
          content: title,
        },
        {
          property: 'og:description',
          content: description,
        },
        {
          property: 'og:image',
          content: image,
        },
        {
          property: 'og:type',
          content: 'website',
        },
        {
          name: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          name: 'twitter:creator',
          content: site.siteMetadata.author,
        },
        {
          name: 'twitter:title',
          content: title,
        },
        {
          name: 'twitter:description',
          content: description,
        },
      ]
        .concat({
          name: 'keywords',
          content: keywords.join(', '),
        })
        .concat(meta)}
    >
      {/* Preconnect CDN */}
      <link rel="preconnect" href={`${CDN_BASE_URL}`} />
      {/* Preload css */}
      <link rel="preload" as="style" href={`${CDN_BASE_URL}/resources/font/pretendard.css`} />
      {/* Preload woff2 fonts */}
      <link
        rel="preload"
        as="font"
        type="font/woff2"
        crossOrigin=""
        href={`${CDN_BASE_URL}/resources/font/pretendard/Pretendard-ExtraBold.subset.woff2`}
      />
      <link
        rel="preload"
        as="font"
        type="font/woff2"
        crossOrigin=""
        href={`${CDN_BASE_URL}/resources/font/pretendard/Pretendard-Bold.subset.woff2`}
      />
      <link
        rel="preload"
        as="font"
        type="font/woff2"
        crossOrigin=""
        href={`${CDN_BASE_URL}/resources/font/pretendard/Pretendard-Medium.subset.woff2`}
      />
      <link
        rel="preload"
        as="font"
        type="font/woff2"
        crossOrigin=""
        href={`${CDN_BASE_URL}/resources/font/pretendard/Pretendard-Regular.subset.woff2`}
      />

      {/* Request stylesheet */}
      <link
        rel="stylesheet"
        type="text/css"
        href={`${CDN_BASE_URL}/resources/font/pretendard.css`}
      />

      <link
        rel="stylesheet"
        href="https://cdn.jsdelivr.net/gh/tonsky/FiraCode@2/distr/fira_code.css"
      />
    </Helmet>
  );
};

export default Head;
